import { mambaFeaturesFlagsParsed } from 'api/api.constants'

export const hasEdnaSupport = (
  features: Partial<Record<number, number>> | null
) => {
  return features?.[mambaFeaturesFlagsParsed.ednaSupport] == 0 || false
}
